$(document).ready(function () {
  // General Message
  $(".generalmessage").prependTo("header");

  $(".mobile-nav-toggle").append(`
    <div></div>
    <div></div>
    <div></div>
    `);

  $("#mobileSearchInput").attr("placeholder", "Search website");
  $("#mobileSearchInput").val("");
  

  $(".groups .group").each(function () {
    let nmbrSlides = 1;
    $(this)
      .find(".items > .item")
      .each(function () {
        let nmbrSubSlides = 1;
        $(this).addClass(`dropdown_menu-${nmbrSlides}`);
        $(this).find(".navClonedItem").remove();
        nmbrSlides++;

        $(this)
          .find(".subitems > .item")
          .each(function () {
            $(this).addClass(`dropdown_submenu-${nmbrSubSlides}`);
            $(this).find(".navClonedItem").remove();
            nmbrSubSlides++;
          });
      });
  });

  $(window).load(function () {
    const sponsorsTitle = $(".homepageh1").text();
    $(".homepageh1").replaceWith(
      `<h2 class="homepageh1">${sponsorsTitle}</h2>`
    );
  });

  $(".footer .emailInputField input").attr("placeholder", "email address");
  $(".footer .emailInputField input").val("");
  $(".footer .emailInputSubmit a").text("join the fun!");
  $(".footer .emailInputSubmit a").addClass("button");
});

$(window).load(function () {
  setTimeout(function () {
    const voidLinks = $("a.void-link");
    voidLinks.removeAttr("href");
    voidLinks.css("pointer-events", "none");
  }, 1500);
});

